import type { ReactNode } from 'react';

import Logotype from 'atoms/logotype';

import headerImage from 'assets/images/header.jpg';

import css from './styles.module.css';

export default function Header(): ReactNode {
	return (
		<header className={css.wrapper}>
			<section className={css.logotype}>
				<Logotype />
			</section>
			<figure className={css.backdrop}>
				<img src={headerImage} className={css.backdropImage} />
			</figure>
		</header>
	);
}
